var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('h3',[_vm._v(" Disaster Names ")]),_c('b-button',{on:{"click":_vm.create}},[_c('b-icon',{attrs:{"icon":"plus"}}),_vm._v(" Create ")],1),_c('b-table',{attrs:{"data":_vm.names,"columns":_vm.columns}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }